import { Link } from "react-router-dom";
import type { CharacterItem } from "@/mocks/characters";

export default function CharacterCard({ item }: { item: CharacterItem }) {
  return (
    <Link
      to={`/characters/detail/${item.id}`}
      className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-square overflow-hidden bg-background-200">
        <img
          src={item.avatar}
          alt={`${item.name} 角色立绘 - ${item.workTitle} - age动漫角色分析`}
          title={`${item.name} - ${item.workTitle} 角色分析`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded bg-background-50/90 text-[11px] text-foreground-800">
          {item.archetype}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-3.5">
        <div className="flex items-center justify-between gap-2">
          <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
            {item.name}
          </h3>
          <span className="text-[10px] tracking-wider text-foreground-400 truncate">{item.romanizedName}</span>
        </div>
        <p className="mt-0.5 text-[11px] text-accent-600">出自《{item.workTitle}》</p>
        <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.summary}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.traits.slice(0, 3).map((trait) => (
            <span key={trait} className="text-[10px] px-1.5 py-0.5 rounded bg-background-100 text-foreground-600">
              {trait}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}